// src/components/Dashboard/DrilldownModal.js
import React, { useState, useEffect } from 'react';
import './DrilldownModal.css'; // <-- 1. Importamos el nuevo CSS

const DrilldownModal = ({ 
  show, 
  handleClose, 
  title, 
  isLoading, 
  ocData,         // <-- 2. Recibimos 'ocData'
  entradasData  // <-- 3. Recibimos 'entradasData'
}) => {
  
  // 4. Estado interno para saber qué pestaña está activa
  const [activeTab, setActiveTab] = useState('oc');

  // Resetea la pestaña a 'oc' cada vez que el modal se abre
  useEffect(() => {
    if (show) {
      setActiveTab('oc');
    }
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show" style={{ display: 'block' }}>
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={handleClose}></button>
            </div>
            <div className="modal-body">
              {isLoading ? (
                <div className="text-center" style={{ padding: '3rem 0' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </div>
                  <p className="mt-2">Consultando datos en SAP...</p>
                </div>
              ) : (
                <>
                  {/* --- 5. La Navegación de Pestañas --- */}
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <button 
                        className={`nav-link ${activeTab === 'oc' ? 'active' : ''}`}
                        onClick={() => setActiveTab('oc')}
                      >
                        Órdenes de Compra Abiertas ({ocData?.length || 0})
                      </button>
                    </li>
                    <li className="nav-item">
                      <button 
                        className={`nav-link ${activeTab === 'entradas' ? 'active' : ''}`}
                        onClick={() => setActiveTab('entradas')}
                      >
                        Entradas Pendientes ({entradasData?.length || 0})
                      </button>
                    </li>
                  </ul>

                  {/* --- 6. El Contenido de las Pestañas --- */}
                  <div className="tab-content">
                    
                    {/* --- Pestaña 1: Órdenes de Compra --- */}
                    {activeTab === 'oc' && (
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th>N° Orden (DocNum)</th>
                              <th>Fecha</th>
                              <th>Monto Total (DocTotal)</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ocData && ocData.length > 0 ? (
                              ocData.map(oc => (
                                <tr key={`oc-${oc.DocEntry}`}>
                                  <td>{oc.DocNum}</td>
                                  <td>{new Date(oc.DocDate).toLocaleDateString()}</td>
                                  <td>${oc.DocTotal.toLocaleString('es-AR')}</td>
                                  <td><span className="badge bg-warning text-dark">Abierta</span></td>
                                </tr>
                              ))
                            ) : (
                              <tr><td colSpan="4" className="text-center">No hay Órdenes de Compra abiertas.</td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* --- Pestaña 2: Entradas de Mercancía --- */}
                    {activeTab === 'entradas' && (
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th>N° Documento (Entrada)</th>
                              <th>Fecha Contabilización</th>
                              <th>N° OC de Referencia</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {entradasData && entradasData.length > 0 ? (
                              entradasData.map(en => (
                                <tr key={`en-${en.DocEntry}`}>
                                  <td>{en.DocNum}</td>
                                  <td>{new Date(en.DocDate).toLocaleDateString()}</td>
                                  <td>{en.BaseDocNum}</td>
                                  <td><span className="badge bg-info text-dark">Pendiente de Factura</span></td>
                                </tr>
                              ))
                            ) : (
                              <tr><td colSpan="4" className="text-center">No hay Entradas de Mercancía pendientes.</td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DrilldownModal;